import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./app/app";
import { ErrorBoundary } from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { InnoveraLoading } from "@libs/zapi-ui/custom";
import { AnalyticsProvider } from "@/zapi-frontend/app/providers/analytics";
import { initChunkLoadErrorHandler } from "@/zapi-frontend/shared/lib/chunkLoadErrorHandler";
import "@/zapi-frontend/shared/i18n";

initChunkLoadErrorHandler();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const queryClient = new QueryClient();

root.render(
  <StrictMode>
    <AnalyticsProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ErrorBoundary
            fallback={<div>Error</div>}
            beforeCapture={(scope) => {
              scope.setTag("location", "app");
            }}
          >
            <App />
            <Toaster
              position="top-right"
              // sonner hardcodes its own font stack on the toaster; inherit the app's Inter instead
              style={{ fontFamily: "inherit" }}
              icons={{ loading: <InnoveraLoading size={20} /> }}
              toastOptions={{ classNames: { title: "text-[14px] leading-[13px] font-medium" } }}
            />
          </ErrorBoundary>
        </BrowserRouter>
      </QueryClientProvider>
    </AnalyticsProvider>
  </StrictMode>
);
